// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00811548","239":"70816f25","455":"ce5508db"}[chunkId] + ".chunk.js";
};